module.exports = __webpack_public_path__ + "img/glarus.df00c6b.png";